import { Controller } from "@hotwired/stimulus";

/**
 * チケット購入確認モーダルコントローラー
 *
 * 責任範囲:
 * - 確認モーダルの表示・非表示制御
 * - 購入内容（枚数・金額）の表示更新
 *
 * 使用シナリオ:
 * - シナリオ(3): ポイント十分な場合
 * - シナリオ(2): 収穫金変換後
 */
export class ConfirmModalController extends Controller {
  static targets = [
    'modal',
    'numberOfTicket',
    'purchaseTicketPrice',
    'purchaseTicketUnitValue'
  ]

  /**
   * モーダルを表示して購入内容を更新
   * @param {Object} data - 表示データ
   * @param {number} data.unit - チケット数量
   * @param {number} data.totalPrice - 合計金額
   */
  show(data) {
    // 購入内容を更新
    this.numberOfTicketTarget.textContent = data.unit;
    this.purchaseTicketPriceTarget.textContent = this.formatCurrency(data.totalPrice);
    this.purchaseTicketUnitValueTarget.value = data.unit;

    // モーダルを表示
    this.modalTarget.style.display = 'block';
    this.modalTarget.style.opacity = 1;
  }

  /**
   * モーダルを閉じる
   * トリガー: 「戻る」ボタンclickイベント
   * HTML: _confirm_modal.html.erb:58
   *       data-action="confirm-modal#close"
   */
  close(event) {
    event.preventDefault();
    this.modalTarget.style.display = 'none';
    this.modalTarget.style.opacity = 0;
  }

  /**
   * 数値をカンマ区切りにフォーマット
   * @param {number} value - フォーマットする数値
   * @returns {string} カンマ区切りの文字列
   */
  formatCurrency(value) {
    return value.toLocaleString('en-US');
  }
}
